import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_MANAGE_DATES = {
  'vehicle': {},
  'loading': false,
};

export const vehicleCertification = (state, action) => {
  return createReducer(INITIAL_STATE_MANAGE_DATES, {
    [ActionTypes.FETCHING_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDING_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': action.response.data,
    }),
    [ActionTypes.ADDED_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': {},
    }),
    [ActionTypes.ADDED_VEHICLE_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAR_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': {},
    }),
  })(state, action);
};
